import { render } from "./DescriptionSkeleton.vue?vue&type=template&id=1411ffc9&scoped=true"
import script from "./DescriptionSkeleton.vue?vue&type=script&lang=js"
export * from "./DescriptionSkeleton.vue?vue&type=script&lang=js"

import "./DescriptionSkeleton.vue?vue&type=style&index=0&id=1411ffc9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1411ffc9"]])

export default __exports__